import { useState } from "react";
import Cleave from "cleave.js/react";
//---------------------------------------------
import Modal from "src/components/common/modal";
import { states, cityStates } from "src/components/common/cityState";
//---------------------------------------------
export default function VendorForm({
    closeIt, 
    handleSubmit, 
    keyword, 
    postUrl, 

    vendorHashKey, 
    vendorName, 
    website, 
    phoneNumber, 
    extension, 
    fax, 
    country, 
    state, 
    city, 
    street, 
    postalCode, 
    background
}){
    //---------------------------------------------
    const [curState, setCurState] = useState(state);
    //---------------------------------------------
    const dataFrame = [
        {label: "Vendor Name", name: "vendorName", defaultValue: vendorName}, 
        {label: "Website", name: "website", defaultValue: website}, 
        {label: "Business Phone", type: "phone", name: "phoneNumber", defaultValue: phoneNumber}, 
        {label: "Extension", name: "extension", defaultValue: extension}, 
        {label: "Fax", type: "phone", name: "fax", defaultValue: fax}, 
        {label: "Country", name: "country", defaultValue: country}, 
        {label: "State", type: "select", options: states, name: "state", defaultValue: state, onChange: e => setCurState(e.currentTarget.value)}, 
        {label: "City", type: "select", options: curState?cityStates[curState]:[], name: "city", defaultValue: city}, 
        {label: "Street", name: "street", defaultValue: street}, 
        {label: "Postal Code", type: "zipCode", name: "postalCode", defaultValue: postalCode}, 
        {label: "Background", type: "textarea", name: "background", defaultValue: background}, 
    ];
    //---------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword} width = {"40rem"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <input className = "nodisplay" readOnly name = "url" value = {postUrl}/>
            <input className = "nodisplay" readOnly name = "vendorHashKey" value = {vendorHashKey ?? ""}/>
            <input className = "nodisplay" readOnly name = "prevVendorName" defaultValue = {vendorName ?? ""}/>
            {dataFrame.map((item, itemIndex) => item.type === "zipCode"?
            <div key = {itemIndex} className = "d-flex align-items-center my-2">
                <label htmlFor = {item.name} className = "font-weight-bold mb-0">{item.label}:</label>
                <Cleave
                    id = {item.name}
                    pattern = "[0-9]{5}"
                    className = "form-control flex-grow-1 ml-2" 
                    name = {item.name}
                    value = {item.defaultValue ?? ""}
                    options = {{
                        blocks:[5], 
                        numericOnly: true,
                    }}
                />
            </div>:
            item.type === "phone"?
            <div key = {itemIndex} className = "d-flex align-items-center my-2">
                <label htmlFor = {item.name} className = "font-weight-bold mb-0">{item.label}:</label>
                <Cleave
                    id = {item.name}
                    pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                    className = "form-control flex-grow-1 ml-2" 
                    name = {item.name}
                    value = {item.defaultValue ?? ""}
                    options = {{
                        blocks:[3, 3, 4],
                        delimiter: "-",
                        numericOnly: true,
                    }}
                />
            </div>:
            item.type === "textarea"?
            <div key = {itemIndex} className = "my-2">
                <label htmlFor = {item.name} className = "font-weight-bold float-left mb-0">{item.label}:</label>
                <textarea
                    id = {item.name}
                    className = "form-control w-100"
                    name = {item.name}
                    defaultValue = {item.defaultValue}
                />
            </div>:
            item.type === "select"?
            <div key = {itemIndex} className = "my-2 d-flex align-items-center my-2">
                <label htmlFor = {item.name} className = "font-weight-bold mb-0">{item.label}:</label>
                <select id = {item.name} className = "form-control flex-grow-1 ml-2" name = {item.name} defaultValue = {item.defaultValue ?? ""} onChange = {item.onChange}>
                    <option value = "">Select</option>
                    {item.options.map((value, index) => <option key = {index}>{value}</option>)}
                </select>
            </div>:
            <div key = {itemIndex} className = "d-flex align-items-center my-2">
                <label htmlFor = {item.name} className = "font-weight-bold mb-0">{item.label}:</label>
                <input
                    autoComplete = {item.autoComplete ?? "off"}
                    id = {item.name}
                    className = "form-control flex-grow-1 ml-2"
                    name = {item.name}
                    defaultValue = {item.defaultValue ?? ""}
                />
            </div>)}
        </Modal>
    )
}